import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import CharacterPage from "@/pages/CharacterPage";

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/characters/:slug" element={<CharacterPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors toastOptions={{ style: { fontFamily: "Fredoka, sans-serif", fontSize: 16 } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
